(function () {
    'use strict';

    angular
        .module('app')
        .controller('UsersEditController', UsersEditController);

    UsersEditController.$inject = ['debug', '$stateParams', 'API', 'config', 'alert', 'i18n', '$q', 'helpers', '$state',];

    function UsersEditController(debug, $stateParams, API, config, alert, i18n, $q, helpers, $state) {
        var vm = this;
        vm.id = $stateParams.id;
        vm.isSaving = false;
        vm.isCreatingNewGroupConnection = false;
        vm.save = save;
        vm.user = {};
        vm.email = '';
        vm.userTypes = [];
        vm.userUsers = [];
        vm.orders = [];
        vm.credit = 0;
        vm.logInAsUser = logInAsUser;
        vm.refreshSubscription = refreshSubscription;
        vm.cancelSubscription = cancelSubscription;
        vm.giveCredit = giveCredit;
        vm.openUpdatePinCodeModal = openUpdatePinCodeModal;
        vm.openDisconnectGroupModal = openDisconnectGroupModal;
        vm.openConnectToAllGroupsModal = openConnectToAllGroupsModal;
        vm.openConnectToGroupModal = openConnectToGroupModal;
        vm.openSendWelcomeMailModal = openSendWelcomeMailModal;
        vm.openLoadSubscriptionOrdersModal = openLoadSubscriptionOrdersModal;
        vm.openLoadSubscriptionLogModal = openLoadSubscriptionLogModal;
        vm.openChangePasswordModal = openChangePasswordModal;
        vm.openRemoveModal = openRemoveModal;
        vm.openSubscriptionFixModal = openSubscriptionFixModal;
        vm.openChangePlanModal = openChangePlanModal;
        vm.seeChanges = seeChanges;
        vm.loadingState = {
            userIsLoading: false,
            cancellingSubscription: false,
            refreshingSubscription: false,
            sendingWelcomeMail: false,
            subscriptionOrders: false,
            givingCredit: false,
            loadingCredit: false,
            playedGames: false,
        };

        vm.groups = [];
        vm.schools = [];
        vm.subscription = {};
        vm.lastPlayedGames = [];

        vm.notEditable = false;
        vm.now = helpers.getDatabaseDatetime();

        vm.resourceExpand = 'groups,school,loginTeacher,loginStudent,loginIusadmin,subscription,meta,loginThirdparty,lastLogin,subscription.plan,lastLoginEvent';

        activate();

        function activate() {
            loadUser();
        }

        function cancelSubscription() {
            var promise = {};
            if (vm.subscription.provider === 'Apple') {
                promise = alert.confirm('cancel-apple-subscription');
            } else {
                promise = alert.confirm('cancel-user-subscription');
            }
            vm.loadingState.cancellingSubscription = true;

            promise.then(function () {
                var promise = API.Subscription.cancel({
                    id: vm.subscription.id
                }).$promise;

                promise.then(function (response) {
                    debug.log(response);
                    vm.subscription = response;
                    if (vm.subscription.provider === 'Apple') {
                        window.toast({
                            message: i18n.get('APPLE_SUBSCRIPTION_CANCEL_EMAIL_SENT'),
                            autoRemoveTime: 5000,
                            type: 'success'
                        });
                    } else {
                        window.toast({
                            message: i18n.get('SUBSCRIPTION_CANCELED'),
                            autoRemoveTime: 5000,
                            type: 'success'
                        });
                    }
                }, function () {
                });
            }, function () {
                debug.log('Canceled alert.');
            })
                .finally(function () {
                    vm.loadingState.cancellingSubscription = false;
                });
        }

        /**
         * This public function will prompt the user for the number of months worth of credit to
         * give to the customer.
         *
         * @return {undefined}
         */
        function giveCredit() {
            alert.prompt('give-credit', {})
                .then(function (form) {
                    var months = form.get('credit-months');

                    vm.loadingState.givingCredit = true;
                    API.Subscription.giveCredit({ id: vm.subscription.id }, { months: months })
                        .$promise
                        .then(function (response) {
                            if (response.success) {
                                loadCredit();
                                vm.now = helpers.getDatabaseDatetime();
                            }

                            vm.loadingState.givingCredit = false;
                        }, function () {
                            vm.loadingState.givingCredit = false;
                        });
                }, function () {
                });
        }

        function loadUser() {
            vm.loadingState.userIsLoading = true;
            var promise = API.User.get({
                id: vm.id,
                expand: vm.resourceExpand,
            }).$promise;

            promise.then(function (response) {
                vm.user = response;

                if (vm.user.loginTeacher && vm.user.loginTeacher.email) {
                    vm.email = vm.user.loginTeacher.email;
                }

                vm.groups = angular.copy(response.groups);
                vm.school = angular.copy(response.school);
                vm.subscription = angular.copy(response.subscription);

                vm.notEditable = vm.user.loginThirdparty !== null;

                vm.url = vm.user.language === 'en' ? config.get('loginSiteEN') : config.get('loginSiteSV');
                debug.log(vm.user);
                vm.loadingState.userIsLoading = false;

                if (!vm.credit && vm.subscription && vm.subscription.provider === 'Stripe') {
                    loadCredit();
                }

                /**
                 * Only load school groups if this is a school user, otherwise all families are returned in the list.
                 */
                if (vm.user.user_type === 'teacher' || vm.user.user_type === 'student') {
                    API.User.get({
                        id: vm.id,
                        expand: 'school.groups',
                    })
                        .$promise
                        .then(function (response) {
                            if (response.school && response.school.groups) {
                                vm.school = response.school;
                            }
                        }, function () {
                        });
                }

                if (vm.user.user_type === 'student' || vm.user.user_type === 'child') {
                    loadPlayedGames();
                }

                if (vm.user.lastLoginEvent && vm.user.lastLoginEvent.value && vm.user.lastLoginEvent.value.startsWith('{')) {
                    vm.user.lastLoginEvent = JSON.parse(vm.user.lastLoginEvent.value);
                }
            }, function () {
            });
        }

        function loadCredit() {
            if (vm.subscription && vm.subscription.id && vm.subscription.provider === 'Stripe' && !vm.loadingState.loadingCredit) {
                vm.loadingState.loadingCredit = true;

                API.Subscription.getCredit({ id: vm.subscription.id })
                    .$promise
                    .then(function (response) {
                        if (response.credit) {
                            vm.credit = response.credit;
                        }

                        vm.loadingState.loadingCredit = false;
                    }, function () {
                        vm.loadingState.loadingCredit = false;
                    });
            }
        }

        function loadPlayedGames() {
            vm.loadingState.playedGames = true;

            API.User.playedGames({ id: vm.user.id })
                .$promise
                .then(function (response) {
                    vm.lastPlayedGames = response;
                    vm.loadingState.playedGames = false;
                }, function () {
                    vm.loadingState.playedGames = false;
                });
        }

        function logInAsUser() {
            var url = vm.user.language === 'en' ? config.get('loginSiteEN') : config.get('loginSiteSV');
            url += '?user=' + JSON.stringify({
                userID: vm.user.id,
                accessToken: vm.user.access_token,
                userType: vm.user.user_type,
                firstName: vm.user.first_name || '',
                lastName: vm.user.last_name || '',
                email: vm.user.loginTeacher && vm.user.loginTeacher.email ? vm.user.loginTeacher.email : '',
                groupID: vm.user.groups && vm.user.groups.length
                    ? vm.user.groups[0].id
                    : null,
                schoolID: vm.user.school && vm.user.school.id ? vm.user.school.id : ''
            });
            var tab = window.open(url);
            tab.focus();
        }

        function openChangePasswordModal() {
            var promise = alert.prompt('change-user-password', { user: vm.user });
            promise.then(function (response) {
                debug.log(response);
                loadUser();
            }, function (response) {
                debug.error(response);
            });
        }

        function openLoadSubscriptionOrdersModal() {
            alert.open('order-history', { subscriptionId: vm.subscription.id });
        }

        function openLoadSubscriptionLogModal() {
            alert.open('subscription-log', { subscriptionId: vm.subscription.id });
        }

        function openUpdatePinCodeModal() {
            var promise = alert.prompt('update-student-pin-code', { student: vm.user });
            promise.then(function (response) {
                debug.log(response);
                loadUser();
            }, function (response) {
                debug.error(response);
            });
        }

        function openConnectToAllGroupsModal() {
            var promise = alert.confirm('connect-teacher-to-all-groups-in-school');
            promise.then(function () {
                var classConnectPromises = [];
                var joinableGroups = getJoinableGroups();
                angular.forEach(joinableGroups, function (group) {
                    var classConnectPromise = API.User.addToGroup({
                        id: vm.id,
                        target: group.id,
                    }).$promise;
                    classConnectPromises.push(classConnectPromise);

                });
                $q.all(classConnectPromises)
                    .then(function () {
                        window.toast({
                            message: i18n.get('JOINED_ALL_SCHOOL_GROUPS'),
                            autoRemoveTime: 5000,
                            type: 'success'
                        });
                        loadUser();
                    }, function () {
                    });
            }, function () {
                debug.log('User canceled confirmation.');
            });
        }

        function openConnectToGroupModal() {
            var joinableGroups = getJoinableGroups();
            var promise = alert.prompt('connect-teacher-to-group', {
                teacher: vm.user,
                groups: joinableGroups
            });
            promise.then(function () {
                loadUser();
            }, function () {
                debug.log('User canceled confirmation.');
            });
        }

        function getJoinableGroups() {
            var joinableGroups = [];
            angular.forEach(vm.school.groups, function (group) {
                var addThis = true;
                angular.forEach(vm.groups, function (userGroup) {
                    if (group.id === userGroup.id) {
                        addThis = false;
                    }
                });
                if (addThis) {
                    joinableGroups.push(group);
                }
            });
            return joinableGroups;
        }

        function openDisconnectGroupModal(groupId) {
            var promise = alert.confirm('disconnect-something');
            promise.then(function () {
                var promise = API.User.removeFromGroup({
                    id: vm.id,
                    target: groupId
                }).$promise;

                promise.then(function () {
                    window.toast({
                        message: i18n.get('CONNECTION_REMOVED'),
                        autoRemoveTime: 5000,
                        type: 'success'
                    });
                    loadUser();
                }, function (response) {
                    window.toast({
                        message: i18n.get('FAILED'),
                        type: 'danger'
                    });
                    debug.error(response);
                });
            }, function () {
                debug.log('Closing modal');
            });
        }

        function openSendWelcomeMailModal() {
            var promise = alert.confirm('send-welcome-mail');
            vm.loadingState.sendingWelcomeMail = true;

            promise.then(function () {
                var promise = API.User.sendWelcome({
                    id: vm.user.id
                }).$promise;

                promise.then(function () {
                    window.toast({
                        message: i18n.get('WELCOME_MAIL_SENT'),
                        autoRemoveTime: 5000,
                        type: 'success'
                    });
                }, function () {
                });
            }, function () {
                debug.log('Closing modal');
            })
                .finally(function () {
                    vm.loadingState.sendingWelcomeMail = false;
                });
        }

        function openRemoveModal() {
            var promise = alert.confirm('remove-item-user');

            promise.then(function () {
                var removePromise = API.User.recycle({ id: vm.id }).$promise;

                removePromise.then(function () {
                    window.toast({
                        type: 'success',
                        autoRemoveTime: 5000,
                        message: i18n.get('USER_RECYCLED')
                    });
                    $state.go('users.list');
                }, function () {
                });
            }, function () {
            });
        }

        function openSubscriptionFixModal() {
            var promise = alert.prompt('fix-subscription', {
                groupId: vm.groups[0].id,
                subscription: vm.subscription
            });
            promise.then(function () {
                window.toast({
                    message: i18n.get('SUBSCRIPTION_FIXED'),
                    autoRemoveTime: 5000,
                    type: 'success'
                });
                loadUser();
            }, function () {
                debug.log('Closing modal');
            });
        }

        function openChangePlanModal() {
            var promise = alert.prompt('change-plan', {
                groupId: vm.groups[0].id,
                subscription: vm.subscription
            });
            promise.then(function () {
                window.toast({
                    message: i18n.get('SUBSCRIPTION_PLAN_CHANGED'),
                    autoRemoveTime: 5000,
                    type: 'success'
                });
                loadUser();
            }, function () {
                debug.log('Closing modal');
            });
        }

        function refreshSubscription() {
            var promise = alert.confirm('refresh-user-subscription');
            vm.loadingState.refreshingSubscription = true;

            promise.then(function () {
                API.Subscription.refresh({
                    id: vm.subscription.id
                })
                    .$promise
                    .then(function (response) {
                        vm.subscription = response;
                        window.toast({
                            message: i18n.get('SUBSCRIPTION_REFRESHED'),
                            autoRemoveTime: 5000,
                            type: 'success'
                        });
                    }, function () {
                    });
            }, function () {
                debug.log('Canceled.');
            })
                .finally(function () {
                    vm.loadingState.refreshingSubscription = false;
                });
        }

        function save() {
            if (!vm.isSaving) {
                vm.isSaving = true;
                var promise = vm.user.$save({ expand: vm.resourceExpand });
                promise.then(function () {
                    window.toast({
                        message: i18n.get('SAVED'),
                        autoRemoveTime: 5000,
                        type: 'success'
                    });
                    vm.now = helpers.getDatabaseDatetime();
                }, function () {
                })
                    .finally(function () {
                        vm.isSaving = false;
                    });
            }
        }

        function seeChanges(log) {
            alert.open('log-changes', { changes: helpers.printObject(log.changes) });
        }
    }
})();